import React from "react";
import "./bottomPart.scss";
import { Box, Divider, Grid } from "@mui/material";
import ArrowRightAltRoundedIcon from "@mui/icons-material/ArrowRightAltRounded";
import { Link } from "react-router-dom";
import brandStore from "../../store/brandStore";

const BottomPart = () => {
  const BrandStore = brandStore();

  const timestamp = Date.now(); // Returns the number of milliseconds since January 1, 1970 UTC
  const dateObject = new Date(timestamp); // Creates a Date object from the timestamp
  const year = dateObject.getFullYear(); // Extracts the full four-digit year

  const onClick = (e) => {
    window.scrollTo({ top: 0 });
  };

  return (
    <div className="bottomPart">
      <Divider />
      <div className="bottom-container">
        <Grid container spacing={2}>
          <Grid item lg={3} md={3} sm={6} xs={12}>
            <Box component="div" className="our-info">
              <h3>Customer Service</h3>
              <div className="links">
                <Link className="link" to="/contact-us" onClick={onClick}>
                  <ArrowRightAltRoundedIcon className="icon" /> Contact Us
                </Link>
                {/* <Link
                  className="link"
                  to="/faqs#RnRQueries"
                  onClick={() => {
                    window.scrollTo({ top: 0 });
                    window.scrollTo({ top: 800, behavior: "smooth" });
                  }}
                >
                  <ArrowRightAltRoundedIcon className="icon" /> Returns &
                  Refunds
                </Link> */}
                <Link className="link" to="/faqs" onClick={onClick}>
                  <ArrowRightAltRoundedIcon className="icon" /> FAQs
                </Link>
                <Link
                  className="link"
                  to="/terms-and-conditions"
                  onClick={onClick}
                >
                  <ArrowRightAltRoundedIcon className="icon" /> Terms &
                  Condition
                </Link>
                <Link className="link" to="/privacy-policy" onClick={onClick}>
                  <ArrowRightAltRoundedIcon className="icon" /> Privacy Policy
                </Link>
                <Link
                  className="link"
                  to="/refund-and-cancellation-policy"
                  onClick={onClick}
                >
                  <ArrowRightAltRoundedIcon className="icon" /> Refund And
                  Cancellation Policy
                </Link>
                <Link
                  className="link"
                  to="/shipping-and-delivery-policy"
                  onClick={onClick}
                >
                  <ArrowRightAltRoundedIcon className="icon" /> Shipping &
                  Delivery Policy
                </Link>
              </div>
            </Box>
          </Grid>
          <Grid item lg={3} md={3} sm={6} xs={12}>
            <Box component="div" className="our-info">
              <h3>Company</h3>
              <div className="links">
                {/* <Link className="link" onClick={onClick}>
                  <ArrowRightAltRoundedIcon className="icon" /> What We Do
                </Link> */}
                <Link className="link" to="/about-us" onClick={onClick}>
                  <ArrowRightAltRoundedIcon className="icon" /> About Us
                </Link>
              </div>
            </Box>
          </Grid>
          <Grid item lg={3} md={3} sm={6} xs={12}>
            <Box component="div" className="our-info">
              <h3>Social Media</h3>
              <div className="links">
                {/* <Link className="link">
                  <ArrowRightAltRoundedIcon className="icon" /> Twitter
                </Link>
                <Link className="link">
                  <ArrowRightAltRoundedIcon className="icon" /> Facebook
                </Link> */}
                <Link
                  className="link"
                  onClick={() =>
                    window.open("https://www.instagram.com/kristiveofficial/")
                  }
                >
                  <ArrowRightAltRoundedIcon className="icon" /> Instagram
                </Link>
              </div>
            </Box>
          </Grid>
          <Grid item lg={3} md={3} sm={6} xs={12}>
            <Box component="div" className="our-info">
              <h3>Profile</h3>
              <div className="links">
                <Link
                  className="link"
                  to="/user/manage-account"
                  onClick={onClick}
                >
                  <ArrowRightAltRoundedIcon className="icon" /> My Account
                </Link>
                <Link className="link" to="/checkout" onClick={onClick}>
                  <ArrowRightAltRoundedIcon className="icon" /> Checkout
                </Link>
                <Link
                  className="link"
                  to="/faqs#shipping"
                  onClick={() => {
                    window.scrollTo({ top: 0 });
                    window.scrollTo({ top: 550, behavior: "smooth" });
                  }}
                >
                  <ArrowRightAltRoundedIcon className="icon" />
                  Order Tracking
                </Link>
                {/* <Link className="link" onClick={onClick}>
                  <ArrowRightAltRoundedIcon className="icon" /> Help & Support
                </Link> */}
              </div>
            </Box>
          </Grid>
        </Grid>
      </div>
      <Divider className="divider" />
      <div className="rights-reserved">
        <p>
          Copyright © {year} {BrandStore.brand.brandName}, All Rights Reserved
        </p>
      </div>
    </div>
  );
};

export default BottomPart;
